// Design tokens — Collabo XD brand.
// Single source of truth for colors, fonts, and tracking.
// Mirrors docs/brand-assets-collaboxd/brand-board.html. Do NOT introduce new
// colors or fonts elsewhere; import from here so we keep the palette honest.

export const COLORS = {
  // ── Core brand ──
  cyan: "#00ADEF",        // CXD Cyan — primary accent
  navy: "#252F6A",        // CXD Navy — primary dark
  coral: "#EF4A2E",       // CXD Coral — energetic accent
  white: "#FFFFFF",

  // ── Expanded accents ──
  sunshine: "#FFC629",
  teal: "#00BFA5",
  lavender: "#8B7EC8",
  peach: "#FF9A76",
  mint: "#8EDCB4",

  // ── Neutrals ──
  lightGray: "#F0F4F8",
  medGray: "#94A3B8",
  darkGray: "#334155",
  offWhite: "#FAFBFC",

  // ── Legacy aliases (preserved so existing consumers keep working). ──
  blue: "#252F6A",        // → CXD Navy
  holidayBlue: "#00ADEF", // → CXD Cyan
  accent: "#00ADEF",      // → CXD Cyan
  deepBlue: "#1A1F4A",
  slateBlue: "#8B7EC8",   // → CXD Lavender
  cream: "#F0F4F8",
  creamLight: "#F0F4F8",
  bgDark: "#252F6A",

  // ── Light theme surfaces ──
  bgApp: "#F0F4F8",       // page background (CXD Light Gray)
  surface: "#FFFFFF",     // card surface on bgApp
  surfaceHigh: "#FAFBFC", // elevated card / hover surface
  border: "rgba(37,47,106,0.10)",
  borderButton: "rgba(37,47,106,0.22)",
  textPrimary: "#252F6A", // CXD Navy
  textSecondary: "#334155", // CXD Dark Gray
  textMuted: "#94A3B8",   // CXD Med Gray
};

export const FONTS = {
  heading:
    "'Bitter', Georgia, 'Times New Roman', serif",
  body:
    "'Assistant', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', sans-serif",
};

export const TRACKING = {
  headline: "0.04em",       // page + section headlines (uppercase)
  level: "0.03em",          // large level labels
  button: "0.08em",         // uppercase button text
  kicker: "0.2em",          // small uppercase eyebrow text
  tightHeadline: "-0.01em", // sentence-case headlines (slight tightening)
};
